import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export const SocialProof = () => {
  const testimonials = [{
    quote: 'Estaba al borde del colapso. Mi bebé de 7 meses se despertaba cada hora. En la tercera noche de aplicar el método, durmió 6 horas seguidas. Lloré de alivio.',
    name: 'María G.',
    baby: 'Mamá de Leo (7 meses)',
    photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: 'Como mamá primeriza, los consejos de internet me tenían confundida. Este protocolo es claro y compasivo. No tuve que dejarla llorar sola.',
    name: 'Sofía R.',
    baby: 'Mamá de Emma (4 meses)',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: 'Tengo gemelos y pensé que nunca volvería a dormir. La técnica de la pausa de 5 minutos cambió nuestras vidas. Ahora ambos duermen sincronizados.',
    name: 'Laura M.',
    baby: 'Mamá de Mateo y Lucas (6 meses)',
    photo: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: "Trabajo a tiempo completo y el agotamiento me estaba destruyendo. Este método nos salvó. El ambiente de la 'Cueva del Sueño' es mágico.",
    name: 'Ana P.',
    baby: 'Mamá de Valentina (9 meses)',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: 'Mi bebé es extremadamente sensible a los ruidos. El enfoque neuro-sensorial tiene todo el sentido del mundo. Ojalá lo hubiera encontrado antes.',
    name: 'Carmen T.',
    baby: 'Mamá de Hugo (5 meses)',
    photo: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=150&h=150&fit=crop&crop=face'
  }, {
    quote: 'Vale cada centavo. Pasamos de 5 despertares a solo 1 para comer. Mi esposo y yo finalmente tenemos tiempo para nosotros en la noche.',
    name: 'Elena V.',
    baby: 'Mamá de Martín (8 meses)',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face'
  }];
  return <section className="py-20 px-6 bg-white" data-id="element-170">
      <div className="max-w-7xl mx-auto" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-173">
            Madres reales. Noches reales.
          </h2>
          <p className="text-lg text-brand-charcoal/70" data-id="element-174">
            Únete a las miles de familias que ya recuperaron su descanso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-175">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-cream p-8 rounded-3xl border border-brand-lavender/15 shadow-sm" data-id="element-176">
              <div className="flex text-brand-gold mb-4" data-id="element-177">
                {[...Array(5)].map((_, index) => <Star key={index} className="w-4 h-4 fill-current" data-id="element-178" />)}
              </div>
              <p className="text-brand-charcoal/90 mb-6 italic leading-relaxed" data-id="element-179">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-180">
                <img src={t.photo} alt={`Foto de ${t.name}`} className="w-14 h-14 rounded-full object-cover border-2 border-brand-lavender/30 shadow-sm" data-id="element-181" />
                <div data-id="element-182">
                  <h4 className="font-bold text-brand-navy" data-id="element-183">{t.name}</h4>
                  <p className="text-sm text-brand-charcoal/60" data-id="element-184">{t.baby}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};